import {FETCH_USER_ASSESSMENTS} from "../actions/action_assessments";

export default function (state=null, action){
    switch (action.type) {
      case FETCH_USER_ASSESSMENTS:
          return action.payload.data.results;
        // no default
    }
    return state;
}